import * as React from "react";
const SvgSend = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 0 24 24", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }), /* @__PURE__ */ React.createElement("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" }));
export default SvgSend;
